import { useEffect, useState } from 'react'

/** Od teto sirky ma appka rozvrzeni pro pocitac: bocni panel, sloupce obchodu, souhrn vpravo. */
export const DESKTOP_QUERY = '(min-width: 64rem)'

function matches(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches
}

export function useDesktop(): boolean {
  const [desktop, setDesktop] = useState(matches)
  useEffect(() => {
    const query = window.matchMedia(DESKTOP_QUERY)
    const onChange = () => setDesktop(query.matches)
    onChange()
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])
  return desktop
}
